import { Link } from 'react-router-dom';
import type { MovieItem } from '@/mocks/movies';

interface MovieCardProps {
  item: MovieItem;
  variant?: 'default' | 'ranking';
  rank?: number;
}

export default function MovieCard({ item, variant = 'default', rank }: MovieCardProps) {
  if (variant === 'ranking' && rank) {
    return (
      <Link
        to={`/article/${item.id}`}
        className="flex items-center gap-3 p-2 rounded-lg hover:bg-background-100 transition-colors cursor-pointer group"
      >
        <span
          className={`w-7 h-7 flex items-center justify-center rounded-full text-sm font-bold flex-shrink-0 ${
            rank <= 3
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-200 text-foreground-600'
          }`}
        >
          {rank}
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-foreground-900 text-sm font-medium truncate group-hover:text-primary-500 transition-colors">
            {item.title}
          </p>
          <p className="text-foreground-500 text-xs mt-0.5">
            {item.year} · {item.category === 'movie' ? '电影' : item.category === 'tv' ? '电视剧' : '综艺'}
          </p>
        </div>
        <div className="flex items-center gap-1 flex-shrink-0">
          <i className="ri-star-fill text-accent-500 text-xs"></i>
          <span className="text-accent-500 text-sm font-semibold">{item.rating}</span>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${item.id}`}
      className="block group cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[2/3] mb-3">
        <img
          src={item.image}
          alt={item.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
        <div className="absolute top-2 right-2 bg-primary-500 text-background-50 text-xs font-bold px-2 py-1 rounded-md">
          {item.rating}
        </div>
        {item.category !== 'movie' && (
          <div className="absolute top-2 left-2 bg-accent-500 text-background-950 text-xs font-semibold px-2 py-1 rounded-md">
            {item.episodes}
          </div>
        )}
        <div className="absolute bottom-2 left-2 right-2">
          <p className="text-background-50 text-xs font-medium truncate opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            {item.description}
          </p>
        </div>
      </div>
      <h3 className="text-foreground-900 text-sm font-semibold truncate group-hover:text-primary-500 transition-colors">
        {item.title}
      </h3>
      <div className="flex items-center gap-2 mt-1.5">
        {item.tags.slice(0, 2).map((tag) => (
          <span
            key={tag}
            className="text-foreground-500 text-xs px-2 py-0.5 bg-background-100 rounded-full"
          >
            {tag}
          </span>
        ))}
      </div>
      <p className="text-foreground-500 text-xs mt-1.5">{item.updateInfo}</p>
    </Link>
  );
}